module.exports = "<img [src]=\" '../../assets/svg-weather/'+this.icon+'.svg ' \" height=\"100\" width=\"100\">\n"